import type { Locale } from '../types';

const messages = {
  en: {
    appName: 'Apple Media Explorer',
    search: 'Search',
    discover: 'Discover',
    detail: 'Detail',
    artist: 'Artist',
    compare: 'Compare',
    saved: 'Saved',
    news: 'Apple News',
    settings: 'Settings',
    searchPlaceholder: 'Search songs, albums, artists, movies, podcasts, apps, books...',
    searchNow: 'Search',
    media: 'Media',
    entity: 'Entity',
    attribute: 'Attribute',
    country: 'Storefront',
    limit: 'Limit',
    explicit: 'Explicit',
    results: 'Results',
    noResults: 'No results yet.',
    noMatches: 'No matching items.',
    loading: 'Loading',
    playPreview: 'Play preview',
    watchPreview: 'Watch preview',
    pausePreview: 'Pause preview',
    pauseWatchPreview: 'Pause preview',
    progress: 'Progress',
    expandPlayer: 'Expand player',
    collapsePlayer: 'Close player',
    nowPlaying: 'Now playing',
    queue: 'Queue',
    previousTrack: 'Previous',
    nextTrack: 'Next',
    downloadArtwork: 'Download artwork',
    openApple: 'Open on Apple',
    favorite: 'Favorite',
    unfavorite: 'Remove favorite',
    favorites: 'Favorites',
    recentSearches: 'Recent searches',
    recentViewed: 'Recently viewed',
    priceCompare: 'Price compare',
    unavailable: 'Unavailable',
    openDetail: 'Open detail',
    viewArtist: 'View artist',
    theme: 'Theme',
    language: 'Language',
    defaultCountry: 'Default storefront',
    cardSize: 'Card size',
    compareCountries: 'Price comparison countries',
    system: 'System',
    light: 'Light',
    dark: 'Dark',
    chinese: 'Chinese',
    english: 'English',
    apply: 'Apply',
    clear: 'Clear',
    remove: 'Remove',
    customFeed: 'Custom feed',
    feed: 'Feed',
    type: 'Type',
    source: 'Source',
    updated: 'Updated',
    officialPage: 'Official page',
    about: 'About',
    trackCount: 'Track count',
    genre: 'Genre',
    released: 'Released',
    price: 'Price',
    related: 'Related',
    emptySaved: 'Saved items will appear here.',
    error: 'Something went wrong.',
    retry: 'Retry',
    all: 'All',
    yes: 'Yes',
    no: 'No',
    view: 'View',
    searchHistoryHint: 'Select a recent search to run it again.',
    newsHint: 'Apple Newsroom and Developer feeds are parsed through the local API proxy.',
    compareHint: 'Compare availability and local pricing across selected Apple storefronts.',
    itemId: 'Item ID'
    ,
    artistInfo: 'Artist info',
    mediaInfo: 'Media info',
    externalData: 'External data',
    wikipedia: 'Wikipedia',
    musicBrainz: 'MusicBrainz',
    close: 'Close',
    duration: 'Duration',
    activeYears: 'Active years',
    trackNumber: 'Track number',
    discNumber: 'Disc number',
    collection: 'Collection',
    identifiers: 'Identifiers',
    movieAndTv: 'Movies & TV',
    poweredBySearch: 'iTunes Search API',
    globalControls: 'Global controls',
    globalControlsHint: 'Default storefront affects Search, Detail, Artist and Compare. Discover uses its own storefront above.',
    enlargePreview: 'Enlarge preview'
  },
  zh: {
    appName: 'Apple Media Explorer',
    search: '搜索',
    discover: '发现',
    detail: '详情',
    artist: '艺人',
    compare: '比价',
    saved: '收藏',
    news: 'Apple 新闻',
    settings: '设置',
    searchPlaceholder: '搜索歌曲、专辑、艺人、电影、播客、App、图书...',
    searchNow: '搜索',
    media: '媒体',
    entity: '类型',
    attribute: '字段',
    country: '商店地区',
    limit: '数量',
    explicit: '限制级内容',
    results: '结果',
    noResults: '还没有搜索结果。',
    noMatches: '没有匹配内容。',
    loading: '加载中',
    playPreview: '播放试听',
    watchPreview: '试看',
    pausePreview: '暂停试听',
    pauseWatchPreview: '暂停试看',
    progress: '进度',
    expandPlayer: '展开播放器',
    collapsePlayer: '关闭播放器',
    nowPlaying: '正在播放',
    queue: '播放列表',
    previousTrack: '上一首',
    nextTrack: '下一首',
    downloadArtwork: '下载封面',
    openApple: '在 Apple 打开',
    favorite: '收藏',
    unfavorite: '取消收藏',
    favorites: '收藏',
    recentSearches: '最近搜索',
    recentViewed: '最近查看',
    priceCompare: '价格比较',
    unavailable: '不可用',
    openDetail: '打开详情',
    viewArtist: '查看艺人',
    theme: '主题',
    language: '语言',
    defaultCountry: '默认商店地区',
    cardSize: '卡片大小',
    compareCountries: '比价地区',
    system: '跟随系统',
    light: '浅色',
    dark: '深色',
    chinese: '中文',
    english: '英文',
    apply: '应用',
    clear: '清空',
    remove: '删除',
    customFeed: '自定义榜单',
    feed: '榜单',
    type: '内容类型',
    source: '来源',
    updated: '更新',
    officialPage: '官方页面',
    about: '简介',
    trackCount: '曲目数',
    genre: '类型',
    released: '发行',
    price: '价格',
    related: '关联内容',
    emptySaved: '收藏内容会显示在这里。',
    error: '出现错误。',
    retry: '重试',
    all: '全部',
    yes: '是',
    no: '否',
    view: '查看',
    searchHistoryHint: '选择最近搜索可再次执行。',
    newsHint: 'Apple 新闻室和开发者 RSS 通过本地 API 代理解析。',
    compareHint: '比较同一内容在不同 Apple 商店的可用性和价格。',
    itemId: '内容 ID',
    artistInfo: '艺人资料',
    mediaInfo: '媒体信息',
    externalData: '外部资料',
    wikipedia: '维基百科',
    musicBrainz: 'MusicBrainz',
    close: '关闭',
    duration: '时长',
    activeYears: '活跃时间',
    trackNumber: '曲目编号',
    discNumber: '碟片编号',
    collection: '专辑 / 集合',
    identifiers: '标识符',
    movieAndTv: '电影与电视',
    poweredBySearch: 'iTunes Search API',
    globalControls: '全局控制',
    globalControlsHint: '默认商店地区会影响搜索、详情、艺人和比价；Discover 榜单使用上方自己的商店地区。',
    enlargePreview: '放大试看'
  }
} satisfies Record<Locale, Record<string, string>>;

export type MessageKey = keyof typeof messages.en;

export function createTranslator(locale: Locale) {
  return (key: MessageKey) => messages[locale][key] ?? messages.en[key] ?? key;
}
